import React from 'react';

const ProductSpinner = () => {
  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
      <div className="product-spinner">
        <div className="spinner-circle"></div>
        <div className="spinner-circle spinner-circle-delayed"></div>
        <div className="spinner-circle spinner-circle-double-delayed"></div>
        <p className="spinner-text">Loading Products...</p>
      </div>

      <style jsx>{`
        .product-spinner {
          position: relative;
          width: 80px;
          height: 80px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .spinner-circle {
          position: absolute;
          width: 50px;
          height: 50px;
          border: 4px solid transparent;
          border-top-color: #ff6701;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        .spinner-circle-delayed {
          width: 40px;
          height: 40px;
          border-top-color: #007bff;
          animation-delay: 0.3s;
        }

        .spinner-circle-double-delayed {
          width: 30px;
          height: 30px;
          border-top-color: #6c757d;
          animation-delay: 0.6s;
        }

        .spinner-text {
          position: absolute;
          bottom: -60px;
          font-size: 14px;
          color: #333;
          font-weight: 500;
          text-align: center;
          animation: pulse 1.5s ease-in-out infinite;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </div>
  );
};

export default ProductSpinner;